import React from "react";
import styles from "./CarouselButton.module.scss";
import classNames from "classnames";
import PlainButton from "../Button/PlainButton/PlainButton";
import ChevronLeftIcon from "../../icons/ChevronLeftIcon";
import ChevronRightIcon from "../../icons/ChevronRightIcon";

const CarouselButton = React.forwardRef(
  (
    {
      className,
      direction,
      onClick,
      size = "small",
      shadow = true,
      stroke,
      ...rest
    }: {
      direction: "left" | "right";
      className?: string;
      onClick?: () => void;
      size?: "small" | "large";
      shadow?: boolean;
      stroke?: string;
    },
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => (
    <PlainButton
      ref={ref}
      className={classNames(
        styles.root,
        styles[size],
        shadow && "shadow",
        className
      )}
      onClick={onClick}
      {...rest}
    >
      {direction === "left" ? (
        <ChevronLeftIcon className={styles.left} stroke={stroke} />
      ) : (
        <ChevronRightIcon className={styles.right} stroke={stroke} />
      )}
    </PlainButton>
  )
);

export default CarouselButton;
